import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import FlagstoneTheme from '../../../Config/flagstoneTheme';

export default function ShiftContent(props) {
    const classes = useStyles();
    const [shifts, setShifts] = useState([])
    const [dataFetched, setDataFetched] = useState(false);


    useEffect(() => {
        let mounted = true
        dataService.getShifts().then(x => {
            if (mounted) {
                if (shifts.length !== x.body.length) {
                    setShifts(x.body)
                    setDataFetched(true)
                }
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        return function cleanup() {
            mounted = false
        }
    }, [shifts]);

    let stringArray = props.performance.split('/')
    let amountPerformed = parseInt(stringArray[0])
    let totalAmount = parseInt(stringArray[1])
    let percentage = String(Math.round((amountPerformed / totalAmount) * 100)) + "%"
    let restPercentage = String(100 - Math.round((amountPerformed / totalAmount) * 100)) + "%"
    let shift = ""
    if (dataFetched) {
        shift = shifts.find(x => x.id === props.shift).time
    }

    return (
        <div className={classes.shiftContainer}>
            <div className={classes.leftContainer}>
                <div className={classes.percentage}>
                    {percentage}
                </div>
                <div className={classes.shift}>
                    {shift}
                </div>
            </div>
            <div className={classes.rightContainer}>
                <div className={classes.performanceNumbers}>
                    <div className={classes.amountPerformed}>
                        {amountPerformed}
                    </div>
                    <div className={classes.totalAmount}>
                        {totalAmount}
                    </div>
                </div>
                <div className={classes.progressBar}>
                    <div className={classes.blueBar} style={{width:percentage}}>

                    </div>
                    <div className={classes.grayBar} style={{width:restPercentage}}>

                    </div>
                </div>
            </div>
        </div>

    )

}

const useStyles = makeStyles(() => ({
    percentage: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#020100',
    },
    shift: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginBottom: "5px"
    },
    leftContainer: {
        float: 'left',
        width: "90px"
    },
    rightContainer: {
        float: 'left',
        width: "calc(100% - 90px)",
        paddingTop:"10px"
    },
    shiftContainer: {
        width: "100%"
    },
    progressBar: {
        width: "100%",
        display: "block"
    },
    performanceNumbers: {
        width: "100%",
        display: "block",
        height: "22px"
    },
    amountPerformed: {
        width: "50%",
        float: 'left',
        textAlign: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color:"#020100"
    },
    totalAmount: {
        width: "50%",
        float: "right",
        textAlign: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color:"#020100"
    },
    grayBar: {
        backgroundColor: "#DEDEDE",
        height:"5px",
        float:"left",
        borderRadius:"0 10px 10px 0"
    },
    blueBar: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        height:"5px",
        float:"left",
        borderRadius:"10px 0 0 10px"
        }
}));